<template>
  <Box>
    <template #handle>
      <Btn @click="activeOpen" v-if="hasPermi('system:sbinfo:batchSbState')">批量修改设备状态</Btn>
      <Btn @click="addNewDevice" type="blue" v-if="false && hasPermi('system:sbinfo:addSbInfo')">新增设备</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="设备编号" prop="nnc">
                    <el-input size="small" v-model.trim="queryParams.nnc"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所在企业" prop="companyname">
                    <el-input size="small" v-model.trim="queryParams.companyname"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <!-- <el-form-item label="系统版本" prop="systemVersion">
                    <el-input
                      size="small"
                      v-model.trim="queryParams.systemVersion"
                    ></el-input>
                  </el-form-item> -->
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="省市区" prop="qy">
                    <Region :qy="queryParams.qy" @change="change" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生产线" prop="sccode">
                    <!-- <el-input
                      size="small"
                      v-model.trim="queryParams.sccode"
                    ></el-input> -->
                    <el-select v-model="queryParams.sccode" size="small" clearable>
                      <el-option v-for="item in sccodes" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="设备状态" prop="sbstate">
                    <el-select v-model="queryParams.sbstate" size="small" clearable>
                      <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :nowStatus="queryParams.sbstate" :selection="true" :loading="loading"
            @change="changeTableSelected">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {
                        color: '',
                      }
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <span v-if="data.head.handle == 'onlineState'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      onlineState.find(
                        (a) => a.value == data.data.onlineState
                      ) || { color: '' }
                    ).color,
                  }"></span>
                  <span>{{
                      (
                        onlineState.find(
                          (a) => a.value == data.data.onlineState
                        ) || { label: "" }
                      ).label
                  }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" @click="handleItem(data.data, '修改详情')"
                    v-if="hasPermi('system:sbinfo:updateSbInfoById')">修改</Btn>
                  <Btn type="text" @click="handleItem(data.data, '设备详情')" v-if="hasPermi('system:sbinfo:query')">
                    设备详情</Btn>
                  <Btn type="text" @click="toPath(`/DeviceOutManagement`, data.data)"
                    v-if="data.data.activeState == '激活' && hasPermi('system:ws:sbwsList')">外设管理</Btn>
                  <Btn type="text" @click="toPath(`/DeployManagement`, data.data)"
                    v-if="data.data.activeState == '激活' && hasPermi('system:bsinfo:sbDeployGl')">部署管理</Btn>
<!--                  <el-popover placement="right" width="700" trigger="click" style="margin: 0 15px"-->
<!--                    v-if="data.data.activeState == '激活' && hasPermi('system:ywuser:ywuserList')">-->
<!--                    <el-table :data="ywryData">-->
<!--                      <el-table-column property="nickName" label="用户昵称"></el-table-column>-->
<!--                      <el-table-column property="userName" label="用户名"></el-table-column>-->
<!--                      <el-table-column property="sex" label="性别">-->
<!--                        <template slot-scope="scope">-->
<!--                          {{ scope.row.sex ? "男" : "女" }}-->
<!--                        </template>-->
<!--                      </el-table-column>-->
<!--                      <el-table-column property="phonenumber" label="电话号码"></el-table-column>-->
<!--                      <el-table-column property="companyname" label="企业名称"></el-table-column>-->
<!--                    </el-table>-->
<!--                    <Btn slot="reference" type="text" @click="getYwryData(data.data)">运维人员</Btn>-->
<!--                  </el-popover>-->
                  <Btn type="text" @click="cancelActiveOrDelete(data.data)"
                    v-if="data.data.activeState == '激活' && hasPermi('system:sbinfo:cancelsActiveById')">解绑</Btn>
                  <Btn type="text" @click="cancelActiveOrDelete(data.data)"
                    v-if="data.data.activeState != '激活' && hasPermi('system:sbinfo:deleteSbInfoById')">删除</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :title="drawerTitle">
        <template #content>
          <el-form :model="addForm" ref="addForm" label-width="130px" :rules="rules" :class="[
            'demo-ruleForm',
            'formBox',
            disabledTitles.includes(drawerTitle) ? 'disabled' : '',
          ]" :disabled="disabledTitles.includes(drawerTitle)">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="编号：" prop="nnc">
                  <el-input size="small" v-model.trim="addForm.nnc" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="型号：" prop="xh">
                  <el-input size="small" v-model.trim="addForm.xh" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="主板物理序列号：" prop="zbcode">
                  <el-input size="small" v-model.trim="addForm.zbcode" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="硬盘物理序列号：" prop="ypcode">
                  <el-input size="small" v-model.trim="addForm.ypcode" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="生产商：" prop="scs">
                  <el-input size="small" v-model.trim="addForm.scs" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产地址：" prop="address">
                  <el-input size="small" v-model.trim="addForm.address" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人：" prop="username">
                  <el-input size="small" v-model.trim="addForm.username" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话：" prop="phone" >
                  <el-input size="small" v-model.trim="addForm.phone" :disabled = "drawerType == 'update'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="生产日期：" prop="sctime">
                  <el-date-picker size="small" v-model="addForm.sctime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :disabled = "drawerType == 'update'">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="设备状态：" prop="sbstate">
                  <el-select v-model="addForm.sbstate" size="small">
                    <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="状态修改时间：" prop="uptime">
                  <el-date-picker size="small" v-model="addForm.uptime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="disabledTitles.includes(drawerTitle)">
                  <el-input size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="状态修改原因：" prop="upremark">
                  <el-input type="textarea" v-model="addForm.upremark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="修改时间：" prop="updateTime">
                  <el-date-picker size="small" v-model="addForm.updateTime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="操作人：" prop="createUser">
                  <el-input size="small" v-model.trim="addForm.createUser" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer v-if="!disabledTitles.includes(drawerTitle)">
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
      <el-dialog title="批量修改设备状态" :visible.sync="activeDialog" width="30%" :before-close="activeClose">
        <el-select v-model="activeDialogValue" size="small">
          <el-option v-for="item in sbstate" :key="item.value" :label="item.label" :value="item.value"
            :disabled="item.value === queryParams.sbstate"></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="activeClose">取 消</el-button>
          <el-button size="small" type="primary" @click="activeCommit">确 定</el-button>
        </span>
      </el-dialog>
    </template>
  </Box>
</template>

<script>
import { sbstate, sccodes, onlineState } from "@/utils/status";
import drawerMixins from "@/components/drawer/drawer";
import Region from "@/components/region";
import {
    addDevice,
    getDeviceList,
    upDateDevice,
    queryDevice,
    batchSbState,
    updateActive,
    equipmentManager, deleteSbInfo,
} from "@/api/DeviceManagement";
import moment from "moment";
import rules from "@/utils/formRules";
import permMixin from "@/mixins/perm";
export default {
  mixins: [drawerMixins, permMixin],
  components: { Region },
  data() {
    return {
      sbstate,
      sccodes,
      onlineState,
      loading: false,
      drawerTitle: "详情",
      drawerType: 'insert',
      disabledTitles: ["设备详情"],
      rules: {
        nnc: rules.nnc,
        xh: rules.xh,
        zbcode: rules.zbcode,
        ypcode: rules.ypcode,
        phone: rules.phone,
        username: rules.username,
      },
      queryParams: {
        nnc: "",
        companyname: "",
        qy: "",
        sccode: "",
        sbstate: "",
        systemVersion: "",
      },
      ywryData: [],
      tableData: [],
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "companycode",
          label: "企业代码",
          textAlign: "center",
        },
        {
          prop: "productionLine",
          label: "生产线",
          textAlign: "center",
        },
        {
          prop: "nnc",
          label: "设备编号",
        },
        {
          prop: "xh",
          label: "型号",
        },
        {
          prop: "sbstate",
          label: "设备状态",
          handle: "status",
          textAlign: "center",
        },
        {
          prop: "onlineState",
          label: "在线状态",
          handle: "onlineState",
          textAlign: "center",
        },
        // {
        //   prop: "scs",
        //   label: "生产商",
        // },
        // {
        //   prop: "username",
        //   label: "联系人",
        // },
        // {
        //   prop: "phone",
        //   label: "联系人电话",
        //   width: 200,
        // },
        {
          prop: "createTime",
          label: "注册时间",
          minWidth: 100,
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          width: 420,
          fixed: "right",
        },
      ],
      tableSelected: [],
      addForm: {
        nnc: "",
        nncBak: "",
        xh: "",
        zbcode: "",
        ypcode: "",
        scs: "",
        address: "",
        username: "",
        createUser: this.$store.state.userStore.userMsg.userName,
        phone: "",
        sctime: "",
        sbstate: "启用",
        uptime: "",
        upremark: "",
        updateTime: "",
        hardwareCode: "",
      },
      initAddForm: {
        nnc: "",
        nncBak: "",
        xh: "",
        zbcode: "",
        ypcode: "",
        scs: "",
        address: "",
        username: "",
        createUser: this.$store.state.userStore.userMsg.userName,
        phone: "",
        sctime: "",
        sbstate: "启用",
        uptime: "",
        upremark: "",
        updateTime: "",
        hardwareCode: "",
      },
      tempData: {
        sbstate: "",
      },
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      activeDialog: false,
      activeDialogValue: "",
    };
  },
  methods: {
    change(val) {
      this.queryParams.qy = val;
    },
    activeClose() {
      this.activeDialog = false;
      this.activeDialogValue = "";
    },
    activeOpen() {
      if (this.tableSelected.length) {
        this.activeDialog = true;
      } else {
        this.$message.info("请选择修改条目");
      }
    },
    activeCommit() {
      this.setStatus();
    },
    addNewDevice() {
      this.drawerTitle = "新增设备";
      this.addForm = {
        ...this.initAddForm,
      };
      this.changeOpen();
    },
    setStatus() {
      if (!this.activeDialogValue) {
        this.$message.info("请选择状态");
        return;
      }
      const params = {
        ids: [...this.tableSelected.map((item) => item.sbId)],
        sbState: this.activeDialogValue,
      };
      batchSbState(params).then((res) => {
        this.getList();
        this.activeDialog = false;
        this.activeDialogValue = "";
      });
    },
    changeTableSelected(arr = []) {
      this.tableSelected = arr;
    },
    async handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.drawerType = 'update'
      this.tempData.sbstate = data.sbstate;
      await queryDevice(data.sbId).then((res) => {
        this.addForm = {
          ...this.addForm,
          ...res.data,
          id: data.sbId,
        };
        this.addForm.nncBak = this.addForm.nnc;
        if (drawerTitle === "修改详情")
          this.addForm.createUser =
            this.$store.state.userStore.userMsg.userName;
      });
      this.changeOpen();
    },
    commitData() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return false;
        if (this.drawerTitle == "新增设备") {
          const params = {
            ...this.addForm,
          };
          delete params.updateTime;
          addDevice(this.addForm).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$refs.addForm.resetFields();
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        } else if (this.drawerTitle == "修改详情") {
          const params = {
            ...this.addForm,
          };
          if (params.sbstate != this.tempData.sbstate)
            params.uptime = params.uptime ? moment().format("YYYY-MM-DD") : '';
          delete params.updateTime;
          upDateDevice(params).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$refs.addForm.resetFields();
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        }
      });
    },
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
      this.queryParams.qy = "";
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getYwryData(data) {
      const params = {
        sbid: data.sbId,
      };
      this.ywryData = [];
      equipmentManager(params).then((res) => {
        this.ywryData = res.data;
      });
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      getDeviceList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
    toPath(path, data) {
      this.$router.push({
        path,
        query: {
          sbId: data.sbId || null,
        },
      });
    },
    cancelActiveOrDelete(data) {
      if (data.activeState == "激活") {
          this.$confirm("解绑将删除采集端所有数据信息，确认要解绑吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
          })
          .then(() => {
              updateActive({
                  id: data.sbId,
              }).then((res) => {
                  this.$message.success(res.msg);
                  this.getList();
              });
          })
          .catch(() => { });
      } else {
          this.$confirm("确认要删除此设备吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
          })
          .then(() => {
              deleteSbInfo({
                  id: data.sbId,
              }).then((res) => {
                  this.$message.success(res.msg);
                  this.getList();
              });
          })
          .catch(() => { });
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.table_main .query {
  min-height: 87px;
  height: 87px;
}
</style>
